import { useEffect } from 'react';
import { Tabs } from 'antd';
import { trackUserIdGa4 } from 'shared/utils/gtag';
import { TrackPagesGA4Enum } from 'enums/global.enum';
import { AgendaCommercialeTabs } from 'enums/project.enum';
import useAgendaCommercialeTabs from './_hooks/useAgendaCommercialeTabs';
import AgendaActions from './agenda-actions';
import AgendaOpportunities from './agenda-opportunities';
import AgendaDashboard from './agenda-dashboard';

const AgendaCommerciale: React.FC = () => {
  const { selectedTab, agendaCommercialeTabs, onChangeTab } = useAgendaCommercialeTabs();

  useEffect(() => {
    trackUserIdGa4(TrackPagesGA4Enum.AGENDA_COMMERCIALE);
  }, []);

  return (
    <>
      <Tabs
        defaultActiveKey={AgendaCommercialeTabs.ACTIONS}
        items={agendaCommercialeTabs}
        onChange={onChangeTab}
      />
      {selectedTab === AgendaCommercialeTabs.ACTIONS && <AgendaActions />}
      {selectedTab === AgendaCommercialeTabs.OPPORTUNITIES && <AgendaOpportunities />}
      {selectedTab === AgendaCommercialeTabs.TAB_2 && <AgendaDashboard />}
    </>
  );
};

export default AgendaCommerciale;
